import { Search } from './search';

/**
 * Get the search object
 * @param _fetch The fetch function
 * @returns The search object
 */
export const useSearch = (_fetch: {
    (input: RequestInfo | URL, init?: RequestInit): Promise<Response>;
    (input: string | URL | globalThis.Request, init?: RequestInit): Promise<Response>;
}): Search => {
    return new Search(_fetch);
};